<template>
    <div class="page">
        <div class="container">
            <div style="display: flex;justify-content: space-between; align-items: flex-end;">
                <app-title>我的优惠券</app-title>
                <app-button size="md" class="gray-solid" @click.native="$refs.addCoupon.visible=true">添加优惠券</app-button>
            </div>

            <div class="tab">
                <div v-for="item in tabList" :key="item.key" class="item" :class="{'active':item.key === status}" @click="status=item.key;getCouponList()">{{item.label}}</div>
            </div>
            <div v-if="couponList.length>0">
                <coupon-item v-for="(item,index) in couponList" :key="index" :info="item"></coupon-item>
            </div>
            <div v-else class="no-list">
                暂无此类优惠券
            </div>
        </div>
        <add-coupon ref="addCoupon"></add-coupon>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import AddCoupon from './Add'
    import CouponItem from './Item'

    export default {
        computed:mapState({
            couponList: state => state.coupon.couponList,
            page: state => state.coupon.page,
        }),
        data() {
            return {
                status:1,
                visible:false,
                tabList:[{
                    key:1,
                    label:'未使用'
                },{
                    key:2,
                    label:'已使用'
                },{
                    key:3,
                    label:'已过期'
                }]
            }
        },
        components:{
            AddCoupon,
            CouponItem
        },
        methods:{
            getCouponList(){
                this.$store.dispatch('coupon/getCouponList',{
                    status:this.status,
                })
            }
        },
        created(){
            this.getCouponList()
        }
    }
</script>

<style lang="scss" scoped>
    .page{
        padding-top: 50px;
    }
    .no-list{
        margin-top: 30px;
    }
    .coupon-card{
        margin-bottom: 20px;
        margin-right: 5px;
    }
    .tab{
        margin-bottom: 20px;
        margin-top: 50px;
        .item{
            display: inline-block;
            margin-right: 30px;
            font-size: 20px;
            font-weight: 300;
            cursor: pointer;
            &:hover{
                font-weight: bold;
            }
            &.active{
                font-weight: bold;
            }
        }
    }
</style>